import React, { Fragment } from 'react';
import { shape, string } from 'prop-types';
import { fullPageLoadingIndicator } from '@magento/venia-ui/lib/components/LoadingIndicator';
import CategoryList from '@magento/venia-ui/lib/components/CategoryList';
import { Meta, StoreTitle } from '@magento/venia-ui/lib/components/Head';
import { useStyle } from '@magento/venia-ui/lib/classify';
import { useIntl } from 'react-intl';
import defaultClasses from '@magento/venia-ui/lib/RootComponents/CMS/cms.module.css';
import { RichContent } from 'src/components';
import { useCmsPage } from './useCmsPage';

var CMSPage = function CMSPage(props) {
  var identifier = props.identifier;
  var talonProps = useCmsPage({
    identifier: identifier
  });
  var cmsPage = talonProps.cmsPage,
      hasContent = talonProps.hasContent,
      rootCategoryId = talonProps.rootCategoryId,
      shouldShowLoadingIndicator = talonProps.shouldShowLoadingIndicator;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var classes = useStyle(defaultClasses, props.classes);

  if (shouldShowLoadingIndicator) {
    return fullPageLoadingIndicator;
  }

  if (hasContent) {
    var title = cmsPage.title,
        meta_keywords = cmsPage.meta_keywords,
        meta_title = cmsPage.meta_title,
        meta_description = cmsPage.meta_description,
        content = cmsPage.content; // const headingElement =
    //   content_heading !== '' ? <h1 className={classes.heading}>{content_heading}</h1> : null;

    var pageTitle = meta_title || title;
    return React.createElement(Fragment, null, React.createElement(StoreTitle, null, pageTitle), React.createElement(Meta, {
      name: "title",
      content: pageTitle
    }), React.createElement(Meta, {
      name: "description",
      content: meta_description
    }), React.createElement(Meta, {
      name: "keywords",
      content: meta_keywords
    }), React.createElement(RichContent, {
      html: content
    }));
  } // Fallback to a category list if there is no cms content.


  return React.createElement(React.Fragment, null);
};

export default CMSPage;
CMSPage.propTypes = {
  id: string,
  classes: shape({
    heading: string
  })
};